import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import storage from "../common/utils/storage";

var u = navigator.userAgent;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
if (isiOS && !window.entryLink) {
  window.entryLink = encodeURIComponent(window.location.href.split("#")[0]);
}

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
}

/*
isRoutes: true为必选项
*/
const routes = [
  {
    path: "/",
    redirect: 'home',
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404/index"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true
    }
  },
  {
    path: "/HubAuthorize",
    name: "HubAuthorize",
    component: () => import("@/views/Authorize/HubAuthorize"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true
    }
  },
  {
    path: "/EnglishRegister",
    name: "EnglishRegister",
    component: () => import("@/views/EnglishRegister/index"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true
    }
  },
  {
    path: "/interest",
    name: "AreaOfInterest",
    component: () => import("@/views/AreaOfInterest/AreaOfInterest"),
    meta: {
      navShow: false,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/home/home"),
    meta: {
      navShow: true,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/department",
    name: "Department",
    component: () => import("@/views/department/department"),
    meta: {
      navShow: true,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/liveList",
    name: "LiveList",
    component: () => import("@/views/live/index"),
    meta: {
      navShow: true,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/noLive",
    name: "NoLive",
    component: () => import("@/views/ContentPage/noLive"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true
    }
  },
  {
    path: "/noContent",
    name: "NoContent",
    component: () => import("@/views/ContentPage/noContent"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true
    }
  },
  {
    path: "/invalidPage",
    name: "InvalidPage",
    component: () => import("@/views/ContentPage/InvalidPage"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true
    }
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("@/views/home/search"),
    meta: {
      navShow: false,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/contentPage",
    name: "Content",
    component: () => import("@/views/ContentPage/ContentPage"),
    meta: {
      navShow: false,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/liveDetails",
    name: "LiveDetails",
    component: () => import("@/views/ContentPage/liveDetails"),
    meta: {
      navShow: false,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/contentyl",
    name: "Contentyl",
    component: () => import("@/views/ContentPage/Contentyl"),
    meta: {
      navShow: false,
      qrcodeShow: true,
      role: false,
      isRoutes: true
    }
  },
  {
    path: "/personalMiddlePage",
    name: "PersonalMiddlePage",
    component: () => import("@/views/mine/middlePage"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '个人中心'
    }
  },
  {
    path: "/Personal",
    name: "Personal",
    component: () => import("@/views/mine/Personal"),
    meta: {
      navShow: true,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '个人中心'
    }
  },
  {
    path: "/xgPersonal",
    name: "xgPersonal",
    component: () => import("@/views/mine/xgPersonal"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '个人中心'
    }
  },
  {
    path: "/JNJPersonal",
    name: "JNJPersonal",
    component: () => import("@/views/mine/JNJPersonal"),
    meta: {
      navShow: true,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '个人中心'
    }
  },
  {
    path: "/xgJNJPersonal",
    name: "xgJNJPersonal",
    component: () => import("@/views/mine/xgJNJPersonal"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '个人中心'
    }
  },
  {
    path: "/PersonalPoster",
    name: "PersonalPoster",
    component: () => import("@/views/mine/PersonalPoster"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
    }
  },
  {
    path: "/FansFollowList",
    name: "FansFollowList",
    component: () => import("@/views/mine/FansFollowList"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
    }
  },
  {
    path: "/myFavorite",
    name: "MyFavorite",
    component: () => import("@/views/mine/myFavorite"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '我的点赞'
    }
  },
  {
    path: "/myCollection",
    name: "MyCollection",
    component: () => import("@/views/mine/myCollection"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '我的收藏'
    }
  },
  {
    path: "/myMeeting",
    name: "MyMeeting",
    component: () => import("@/views/mine/myMeeting"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '我的预约'
    }
  },
  {
    path: "/browseRecords",
    name: "BrowseRecords",
    component: () => import("@/views/mine/browseRecords"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '历史记录'
    }
  },
  {
    path: "/myQRcode",
    name: "MyQRcode",
    component: () => import("@/views/mine/myQRcode"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '邀请码'
    }
  },
  {
    path: "/JNJQRcode",
    name: "JNJQRcode",
    component: () => import("@/views/mine/JNJQRcode"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true,
      title: '邀请码'
    }
  },
  {
    path: "/myInvitation",
    name: "MyInvitation",
    component: () => import("@/views/mine/myInvitation"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/privacyPolicy",
    name: "PrivacyPolicy",
    component: () => import("@/views/PrivacyPolicy/index"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true,
    }
  },
  {
    path: "/privacyPolicy_EN",
    name: "ENPrivacyPolicy",
    component: () => import("@/views/PrivacyPolicy/english"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true,
    }
  },
  {
    path: "/xgPrivacyPolicy",
    name: "xgPrivacyPolicy",
    component: () => import("@/views/PrivacyPolicy/xgIndex"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true,
    }
  },
  {
    path: "/newProduct",
    name: "NewProduct",
    component: () => import("@/views/newProduct/newProduct"),
    meta: {
      navShow: false,
      qrcodeShow: false,
      role: false,
      isRoutes: true,
    }
  },
  {
    path: "/activityList",
    name: "ActivityList",
    component: () => import("@/views/Activity/list"),
    meta: {
      navShow: false,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  },
  {
    path: "/activityDetails",
    name: "ActivityDetails",
    component: () => import("@/views/Activity/details"),
    meta: {
      navShow: false,
      qrcodeShow: true,
      role: true,
      isRoutes: true
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
});

if (process.env.NODE_ENV == 'development') {
  let userInfo = {
    Id: 1,
    UserName: '',
    HospitalTitle: '',
    PositionalName: '',
    SubjectName: '',
    Email: '',
    Type: 1,
    IsIndex: false,
    certificate_status: 2
  };
  sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
}

router.beforeEach((to, from, next) => {
  console.log(to, from);
  if (to.path != '/HubAuthorize') {
    sessionStorage.setItem('lastPath', to.path);
  }
  
  let userInfo = sessionStorage.getItem("userInfo");
  if(userInfo) {
    // store.dispatch('setUserInfo', { userInfo: userInfo });
    store.dispatch('setUserInfo', { userInfo: JSON.parse(userInfo) });
    console.log('有userInfo直接进入-------------------')
    next();
  } else if(to.path == '/HubAuthorize' || to.path == '/EnglishRegister' || to.path == '/newProduct') {
    console.log('无需用户验证直接进入-------------------')
    next();
  } else {
    if(to.query.userId) {
      console.log('拿到userId获取用户信息-------------------')
      Vue.prototype.$axios.post('/Api/Api/Web/Customer/GetCustmAll', {
        uid: to.query.userId
      }).then(res => {
        let data = res.Data;
        if(data) {
          sessionStorage.setItem("userInfo", JSON.stringify(data));
          store.dispatch('setUserInfo', { userInfo: data });

          Vue.prototype.$axios.post('/Api/Api/Web/Customer/GetUserInfo', {
            id: data.Id
          }).then(res => {
            sessionStorage.setItem("userInfo", JSON.stringify(res.Data));
            store.dispatch('setUserInfo', { userInfo: res.Data });
          })
          console.log('userId拿到用户信息进入-------------------')
          next();
          
          // Vue.prototype.$axios.post('/Api/Api/Web/Customer/GetUserIsFollow', {
          //   userid: data.Id,
          //   type: 1
          // }).then(res => {
          //   let data = res.Data;
          //   if(data && data == 1) {
          //     store.commit('updateFollowShow', false);
          //   } else {
          //     store.commit('updateFollowShow', true);
          //   }
          // })
        } else {
          next('/404');
        }
      })
    } else if(to.path == '/404') {
      next();
    } else {
      next("/404");
    }
  }
})

router.afterEach((to, from) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = '术韵';
  }
})

export default router;
